module.exports = __webpack_public_path__ + "img/img2.4466f323.jpg";